import { css } from '@emotion/css';

const temporalToolbarButtonRules = {
  appearance: 'none',
  alignItems: 'center',
  background: 'var(--streamlain-v2-layer-background-primary)',
  border: '1px solid var(--streamlain-v2-layer-insideBorder-border)',
  borderRadius: '4px',
  color: 'var(--streamlain-v2-text-primary)',
  cursor: 'pointer',
  display: 'inline-flex',
  fontSize: 'var(--streamlain-font-xs)',
  gap: '6px',
  height: '30px',
  justifyContent: 'center',
  lineHeight: 1,
  padding: '0 10px',
  userSelect: 'none',
  transition: 'background 0.12s ease-out, border-color 0.12s ease-out',

  '&:hover': {
    background: 'var(--streamlain-v2-layer-background-hoverOverlay)',
    borderColor: 'var(--streamlain-v2-brand-primary)',
  },

  '&:disabled': {
    cursor: 'not-allowed',
    opacity: 0.5,
  },

  '&&&[data-active=true]': {
    background: 'var(--streamlain-v2-button-primary)',
    borderColor: 'var(--streamlain-v2-button-primary)',
    color: 'var(--streamlain-v2-button-pureWhiteText)',
  },
} as const;

export const temporalToolbarStyle = css({
  alignItems: 'center',
  background: 'var(--streamlain-v2-layer-background-primary)',
  borderBottom: '1px solid var(--streamlain-v2-layer-insideBorder-border)',
  display: 'flex',
  flexWrap: 'wrap',
  gap: '6px',
  justifyContent: 'space-between',
  minWidth: 0,
  padding: '8px 16px',

  '&[data-bottom-border="false"]': {
    borderBottom: 'none',
  },
});

export const temporalToolbarGroupStyle = css({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  gap: '6px',
  minWidth: 0,
});

/**
 * Previous/today/next plus the range title. The group takes the toolbar's
 * free space from a fixed basis and keeps its content left-aligned, so the
 * buttons stay put and the wrap point does not depend on the title: a
 * longer or shorter range title only uses space to the right of the
 * buttons and is ellipsized when it does not fit.
 */
export const temporalToolbarRangeGroupStyle = css({
  alignItems: 'center',
  display: 'flex',
  flex: '1 1 240px',
  flexWrap: 'nowrap',
  gap: '6px',
  minWidth: 0,
});

export const temporalToolbarButtonStyle = css(temporalToolbarButtonRules);

export const temporalToolbarIconButtonStyle = css({
  ...temporalToolbarButtonRules,
  minWidth: '30px',
  padding: 0,
  width: '30px',
});

export const temporalToolbarPrimaryButtonStyle = css({
  ...temporalToolbarButtonRules,
  '&&&': {
    background: 'var(--streamlain-v2-button-primary)',
    borderColor: 'var(--streamlain-v2-button-primary)',
    color: 'var(--streamlain-v2-button-pureWhiteText)',
  },
});

export const temporalToolbarRangeTitleStyle = css({
  color: 'var(--streamlain-v2-text-primary)',
  flex: '1 1 auto',
  fontSize: '14px',
  fontVariantNumeric: 'tabular-nums',
  fontWeight: 600,
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});
